module.exports = __webpack_public_path__ + "img/logo.44e11119.svg";